<template>
    <v-container>
        <h1>Configuración</h1>
        <v-card tile>
            <v-card-title>
                Cambiar tema
            </v-card-title>
            <v-card-text>
                <p class="font-weight-medium">
                    Aquí puedes activar o desactivar el tema oscuro de la aplicación
                </p>
                <v-btn outlined @click="cambiarTema()"> 
                    <span v-if="$vuetify.theme.dark">
                        <v-icon
                            left
                            dark
                        >
                            mdi-theme-light-dark
                        </v-icon>
                        Desactivar tema oscuro
                    </span> 
                    <span v-else>
                        <v-icon
                            left
                        >
                            mdi-theme-light-dark
                        </v-icon>
                        Activar tema oscuro
                    </span> 
                </v-btn>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
export default {
    name: 'Configuracion',
    data () {
        return {
            tema: 'oscuro'
        }
    },
    methods: {
        cambiarTema() {                     
            this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
            localStorage.themeDark = this.$vuetify.theme.dark;
        }
    }
}
</script>